import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';

import { useAppDispatch } from '../..';
import * as loginActions from '../../store/actions/login';
import Logout from '../sidebar/Logout';
import { AppointmentService } from '../../core/http/service/AppointmentService';
import OpenAppointmentsModal from '../openAppointmentsModal/OpenAppointmentsModal';
import { Roles } from '../../enums/Roles';

interface ISideBarFooter {
  isCollapsed?: boolean;
}

const SideBarFooter = ({ isCollapsed }: ISideBarFooter) => {
  const { currentProfile } = useSelector((state: any) => state.login);
  const [showOpenAppointmentsModal, setShowOpenAppointmentsModal] = useState(false);
  const [pendingAppointments, setPendingAppointments] = useState<any[]>([]);
  const [loadingLogout, setLoadingLogout] = useState(false);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const logout = async () => {
    setLoadingLogout(true);
    const rolesToWarn = ["MED", "ENF", "PSI", "NUT", Roles.MED, Roles.ENF, Roles.PSI, Roles.NUT];
    const isHealthProfessional = rolesToWarn.includes(currentProfile);

    if (isHealthProfessional) {
      const appointmentService = new AppointmentService();
      try {
        const pendingResponse: any = await appointmentService.getPendingAppointments();
        const pendingData = pendingResponse.data.data || [];

        if (pendingData && pendingData.length > 0) {
          setPendingAppointments(pendingData);
          setShowOpenAppointmentsModal(true);
          setLoadingLogout(false);
          return;
        }
      } catch (error) {
        console.error("Erro ao buscar atendimentos pendentes no logout:", error);
      }
    }

    try {
      await dispatch(loginActions.logout());
      navigate('/');
    } catch (error) {
      console.error("Erro ao buscar atendimentos pendentes no logout:", error);
      await dispatch(loginActions.logout());
      navigate('/');
    } finally {
      setLoadingLogout(false);
    }
  };

  const confirmLogout = async () => {
    setShowOpenAppointmentsModal(false);
    await dispatch(loginActions.logout());
    navigate('/');
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Logout onLogoutClick={logout} loading={loadingLogout} isCollapsed={isCollapsed} />

      <OpenAppointmentsModal
        visible={showOpenAppointmentsModal}
        appointments={pendingAppointments}
        isLogout={true}
        onConfirm={confirmLogout}
        onCancel={() => setShowOpenAppointmentsModal(false)}
      />
    </Box>
  );
};

export default SideBarFooter;